import ChartProp from "../types/prop.chart";

const labels = ["January", "February", "March", "April", "May", "June", "July"];
const getRandomNumber = (min = 0, max = 1000) =>
  Math.floor(Math.random() * (max - min + 1)) + min;
const data = {
  labels,
  datasets: [
    {
      label: "Dataset 1",
      data: labels.map(() => getRandomNumber()),
      backgroundColor: "rgba(255, 99, 132, 0.5)",
    },
    {
      label: "Dataset 2",
      data: labels.map(() => getRandomNumber()),
      backgroundColor: "rgba(53, 162, 235, 0.5)",
    },
  ],
};

export const chartdata: ChartProp[] = [
  {
    type: "line",
    data: data,
    options: {
      scales: {
        y: {
          beginAtZero: true,
        },
      },
    },
  },

  {
    type: "bar",
    data: data,
    options: {
      scales: {
        y: {
          beginAtZero: true,
        },
      },
    },
  },
  {
    type: "pie",
    data: data,
    options: {
      scales: {
        y: {
          beginAtZero: true,
        },
      },
    },
  },
  // {
  //   type: "scatter",
  //   data: {
  //     datasets: [
  //       {
  //         label: "Scatter Dataset",
  //         data: [
  //           { x: -10, y: 0 },
  //           { x: 0, y: 10 },
  //           { x: 10, y: 5 },
  //           // Add more data points here...
  //         ],
  //         backgroundColor: "rgba(0, 123, 255, 0.5)",
  //       },
  //     ],
  //   },
  //   options: {
  //     scales: {
  //       y: {
  //         beginAtZero: true,
  //       },
  //     },
  //   },
  // },
  // {
  //   type: "radar",
  //   data: data,
  //   options: {
  //     scales: {
  //       y: {
  //         beginAtZero: true,
  //       },
  //     },
  //   },
  // },
];
